<template>
  <g>
    <path
      d="M12 18.0002C12.5523 18.0002 13 17.5525 13 17.0002C13 16.4479 12.5523 16.0002 12 16.0002C11.4477 16.0002 11 16.4479 11 17.0002C11 17.5525 11.4477 18.0002 12 18.0002Z"
    />
    <path
      d="M7 13.0002C7.55228 13.0002 8 12.5525 8 12.0002C8 11.4479 7.55228 11.0002 7 11.0002C6.44772 11.0002 6 11.4479 6 12.0002C6 12.5525 6.44772 13.0002 7 13.0002Z"
    />
    <path
      d="M17 13.0002C17.5523 13.0002 18 12.5525 18 12.0002C18 11.4479 17.5523 11.0002 17 11.0002C16.4477 11.0002 16 11.4479 16 12.0002C16 12.5525 16.4477 13.0002 17 13.0002Z"
    />
    <path
      d="M12 3.00018C11.45 3.00018 11 3.45018 11 4.00018V6.00018C11 6.55018 11.45 7.00018 12 7.00018C12.55 7.00018 13 6.55018 13 6.00018V5.08018C16.31 5.56018 18.87 8.33018 19 11.7402C19.14 15.5902 15.97 18.9402 12.12 19.0002C8.19 19.0602 5 15.9102 5 12.0002C5 10.3202 5.59 8.78018 6.58 7.58018L11.29 12.3002C11.68 12.6902 12.31 12.6902 12.7 12.3002C13.09 11.9102 13.09 11.2802 12.7 10.8902L7.26 5.46018C6.88 5.08018 6.26 5.07018 5.86 5.44018C4.1 7.07018 3 9.40018 3 12.0002C3 17.0402 7.14 21.1202 12.21 21.0002C16.91 20.8902 20.84 16.9902 20.99 12.2902C21.16 7.19018 17.07 3.00018 12 3.00018Z"
    />
  </g>
</template>
